import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';

const DeletedAccounts = () => {
  const [deletedAccounts, setDeletedAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchDeletedAccounts();
  }, []);


  const token = localStorage.getItem("adminToken");

  const fetchDeletedAccounts = async () => {
    try {
      const response = await axios.get(
        'https://afric-fresh-backend.onrender.com/admin/deleted-accounts'
        // "http://localhost:3005/admin/deleted-accounts"
        ,{
          headers: {
            Authorization: `Bearer ${token}`
          }},);
      setDeletedAccounts(response.data);
      
      // Mark deleted accounts as viewed
      await axios.put(
        'https://afric-fresh-backend.onrender.com/admin/deleted-accounts/mark-viewed'
        //  "http://localhost:3005/admin/deleted-accounts/mark-viewed"
        ,{
          headers: {
            Authorization: `Bearer ${token}`
          }});
      
      setLoading(false);
    } catch (err) {
        console.log(err)
      setError('Failed to fetch deleted accounts');
      setLoading(false);
    }
  };

  if (loading) return <div className="flex justify-center items-center h-screen">Loading...</div>;
  if (error) return <div className="text-red-500 text-center">{error}</div>;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Deleted Accounts</h1>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white shadow-md rounded-lg">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">User</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contact</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Reason</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Deleted At</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Account Age</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {deletedAccounts.map((account) => (
              <tr key={account._id}>
                <td className="px-6 py-4">
                  <div className="text-sm font-medium text-gray-900">
                    {account.firstName} {account.lastName}
                  </div>
                </td>
                <td className="px-6 py-4">
                  <div className="text-sm text-gray-500">{account.email}</div>
                  <div className="text-sm text-gray-500">{account.phoneNumber}</div>
                </td>
                <td className="px-6 py-4">
                  <div className="text-sm text-gray-900">{account.deletionReason}</div>
                </td>
                <td className="px-6 py-4">
                  <div className="text-sm text-gray-500">
                    {moment(account.deletedAt).format('MMMM Do YYYY, h:mm a')}
                  </div>
                </td>
                <td className="px-6 py-4">
                  <div className="text-sm text-gray-500">
                    {moment(account.deletedAt).diff(moment(account.originalCreatedAt), 'days')} days
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DeletedAccounts;